import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
const items = [{
  text: '"El Tomo 1 sobre el sueño me salvó literalmente. Por fin entendí por qué se despertaba tanto y pude hacer algo concreto. La primera semana ya notamos la diferencia."',
  author: 'Miguel A. — Sevilla'
}, {
  text: '"El Tomo 2 sobre el postparto fue el que más necesitaba y el que menos esperaba. Mi pareja y yo lo leímos juntos y fue la primera conversación real que tuvimos sobre cómo nos sentíamos los dos."',
  author: 'Javier y Laura P. — Málaga'
}, {
  text: '"Práctico, directo y sin relleno. Cada tomo va al grano. No es teoría de crianza perfecta. Es información real para situaciones reales."',
  author: 'Carmen L. — Zaragoza'
}, {
  text: '"Ha sido la mejor inversión del primer año de crianza. Y eso que hemos comprado de todo."',
  author: 'David M. — Alicante'
}];
export function SecondaryTestimonials() {
  return <section className="bg-white py-20 px-5" data-id="element-161">
      <div className="max-w-[1000px] mx-auto" data-id="element-162">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2" data-id="element-163">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-164">
              <TestimonialCard {...item} data-id="element-165" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}